import Entity from './entity'
import { getShaded } from '../config/colors'

class Color extends Entity {
  toString() {
    return getShaded(this)
  }
}

export default Color



// WEBPACK FOOTER //
// ./src/entities/color.js